export default {
  "basic-layout": () => import("/app/layouts/basicLayout.vue").then(m => m.default || m),
  brand: () => import("/app/layouts/brand.vue").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  "search-basic-layout": () => import("/app/layouts/searchBasicLayout.vue").then(m => m.default || m)
}